import { CommonModule } from "@angular/common";
import { Input, Component, forwardRef } from "@angular/core";
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { ColorPickerModule } from "ngx-color-picker";
import { Output } from "@angular/core";
import { EventEmitter } from "@angular/core";

@Component({
  imports: [CommonModule, FormsModule, ColorPickerModule, OverlayPanelModule],
  standalone: true,
  selector: "nis-color-selector",
  templateUrl: "./color-selector.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ColorSelectorComponent),
      multi: true,
    },
  ],
})
export class ColorSelectorComponent implements ControlValueAccessor {
  @Input() brandColors: string[] = [];

  private onChange: (value: string) => void;
  private onTouched: () => void;
  @Output() colorChange: EventEmitter<string> = new EventEmitter<string>();
  selectedColor: string;

  writeValue(value: string): void {
    this.selectedColor = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Handle the disabled state if needed
  }

  selectColor(color: string): void {
    if (this.onChange) {
      this.onChange(color);
    }
    if (this.onTouched) {
      this.onTouched();
    }
  }
}
